import OspreyTagSearch from './tags-search'
import OspreyTagDelete from './tags-delete'
import OspreyTagCreate from './tags-create'
import OspreyTagUpdate from './tags-update'

export default class Tags {

    search(dataKey) {
        return new OspreyTagSearch(dataKey)
    }

    delete() {
        return new OspreyTagDelete()
    }

    create() {
        return new OspreyTagCreate()
    }

    update() {
        return new OspreyTagUpdate()
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/tags/index.js